import {
    Swiper,
    Navigation,
    Pagination,
    Keyboard,
    Autoplay,
    EffectFade,
} from 'swiper';

Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade ]);

//   const navigation = (target) => {
//     return {
//       nextEl: `.${target}-swiper-button--next`,
//       prevEl: `.${target}-swiper-button--prev`,
//     };
//   };

$(window).on('load', function () {
    swipers();
});

const swipers = () => {
    sliderSwiper();
    partnerSwiper();
};

const sliderSwiper = () => {
    return new Swiper('.module--slider__swiper', {
        loop: true,
        spaceBetween: -1,
        allowTouchMove: true,
        slidesPerView: 1.5,
        centeredSlides: true,
        breakpoints: {
        1200: {
            slidesPerView: 2.5,
        },
        },
    });
};

const partnerSwiper = () => {
    return new Swiper('.module--partners__wrapper__items', {
        loop: true,
        freeMode: true,
        autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        stopOnLastSlide: false,
        waitForTransition: true,
        },
        speed: 3000,
        spaceBetween: 30,
        centerInsufficientSlides: true,
        freeModeMomentum: true,
        breakpoints: {
        1200: {
            slidesPerView: 5,
        },
        768: {
            slidesPerView: 3,
        },
        0: {
            slidesPerView: 2,
        },
        },
    });
};
